import { makeStyles, createStyles, Theme } from '@material-ui/core';

import { centeredMargin } from '../../styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    text: {
      margin: '0 2px 25px 1px',
      fontSize: '18px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.28',
      letterSpacing: 'normal',
      color: '#364343',
    },
    swipable: {
      ...centeredMargin,
    },
    button: {
      borderRadius: 24,
      backgroundColor: '#5f7ccf',
      padding: `8px ${theme.spacing(7)}px`,
      textTransform: 'none',
      fontSize: '18px',
      '&.MuiButton-contained.Mui-disabled': {
        backgroundColor: '#5f7ccf',
        opacity: '0.5',
        color: '#ffffff',
      }
    },
    buttonDisabled: {
    },
    noBoxShadow: {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      }
    },
    secondaryButton: {
      borderRadius: 4,
      backgroundColor: '#f1f5ff',
      padding: '3px 10px',
      textTransform: 'none',
      fontSize: '14px',
      fontWeight: 500,
      color: '#5f7ccf',
      border: 'none',
      '&:hover': {
        border: 'none'
      }
    },
    locationOption: {
      width: '100%',
      display: 'flex',
      height: 80,
      cursor: 'pointer',
      borderBottom: '1px solid #d3d3d3',
      '& img': {
        width: 50,
        height: 50,
        borderRadius: '100%',
        objectFit: 'cover',
        marginTop: 20,
        marginLeft: 10,
      },
      '& p': {
        paddingLeft: 15,
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 10,
        width: 'calc(100% - 60px)',
        '&:last-child': {
          borderBottom: 'none !important',
        },
      },
    },
    providerContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: 'calc(100% - 75px)',
      boxSizing: 'border-box',
      marginLeft: theme.spacing(2),
      marginTop: theme.spacing(1),
    },
    providerName: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
    },
    providerAddress: {
      color: '#9b9999',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
    },
    providerPreviewImgSelect: {
      display: 'inline-flex',
      background: '#e3eded center',
      width: 50,
      height: 50,
      marginTop: 20,
      marginLeft: 10,
      borderRadius: '100%',
      objectFit: 'cover',
      justifyContent: 'center',
      alignItems: 'center',

      '& svg': {
        height: 35,
        width: 40,
        fill: '#bfcfcf',
      },
    },
    searchBox: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: 560,
      width: '100%',
      height: 100,
      borderRadius: '20px',
      backgroundColor: '#f4f8f8',
      fontSize: '14px',
      fontWeight: 500,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: '#626f6f',
      '& svg': {
        marginRight: theme.spacing(0),
      },
      '& div': {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      [theme.breakpoints.down('xs')]: {
        padding: `0 ${theme.spacing(4)}px `,
        height: 200,
        '& svg': {
          marginRight: theme.spacing(2),
        },
      },
    },
    labelForInput: {
      marginBottom: theme.spacing(1),
      fontFamily: 'Roboto',
      fontSize: '15px',
      fontWeight: 500,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
    },
    alignRightContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    alignCenterContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
    },
    providerPreviewImgPill: {
      display: 'inline-flex',
      background: '#e3eded center',
      minWidth: 75,
      width: 75,
      height: 75,
      marginRight: 18,
      borderRadius: '100%',
      objectFit: 'cover',
      justifyContent: 'center',
      alignItems: 'center',

      '& svg': {
        height: 35,
        width: 40,
        fill: '#bfcfcf',
      },
    },
    providerPreviewImgPillMobile: {
      display: 'inline-flex',
      background: '#e3eded center',
      width: 50,
      height: 50,
      marginRight: 10,
      borderRadius: '100%',
      objectFit: 'cover',
      justifyContent: 'center',
      alignItems: 'center',

      '& svg': {
        height: 35,
        width: 40,
        fill: '#bfcfcf',
      },
    },
    providerPillName: {
      fontSize: '16px',
      fontWeight: 500,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: '#364343',
      marginBottom: theme.spacing(1),
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      width: '100%',
    },
    providerPillAddress: {
      fontSize: '14px',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: '#364343',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      width: '100%',
    },
  }),
);
